import { useEffect, useState } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { Box, Button, Container, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { useLocale } from "../contexts/LocaleContext";
import { joinTeam } from "../utils/firebase";

export default function InvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { basePath, localizePath } = useLocale();
  const { user, loading: authLoading } = useAuth();
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !token) return;
    let cancelled = false;
    setJoining(true);
    setError(null);
    joinTeam({ inviteToken: token })
      .then(() => {
        if (!cancelled) navigate(localizePath("/"), { replace: true });
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || t("invitePage.failedToJoin"));
      })
      .finally(() => {
        if (!cancelled) setJoining(false);
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once when user/token available
  }, [user, token]);

  if (authLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    const invitePath = `${basePath || ""}/invite/${token}`.replace("//", "/");
    return <Navigate to={`${basePath || ""}/login?redirect=${encodeURIComponent(invitePath)}`} replace />;
  }

  if (joining) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
        <CircularProgress />
        <Typography>{t("invitePage.joiningTeam")}</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="sm" sx={{ py: 8, textAlign: "center" }}>
        <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
        <Button variant="contained" onClick={() => navigate(localizePath("/"))}>{t("invitePage.goToDashboard")}</Button>
      </Container>
    );
  }

  return null;
}
